<div fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="1em">
    <span class="viewer" [ngStyle]="{'background-color': backgroundFn(value, max)}">
        <span *ngIf="transformFn then transformed else notTransformed"></span>
        <ng-template #transformed>
            {{transformFn(value)?.key | translate: transformFn(value)?.params}}
        </ng-template>
        <ng-template #notTransformed>
            {{value ? value + ' ' + unit : 'emptyValue' | translate}}
        </ng-template>
        </span>
    <p-slider *ngIf="!disabled" class="slider" [step]="step" [min]="min" [max]="max" (onChange)="change($event.value)" [(ngModel)]="value"></p-slider>
</div>
